import React from 'react';
import { TableV2Column } from 'components/Table/TableV2';
import { ConversationTagsCell } from '../components/ConversationTagsCell';

// Not a ConversationFilterIds member: tag chips key their state per tag.
const TAGS_COLUMN_ID = 'tags';

type TaggedRow = {
  tags?: string[] | null;
};

/**
 * The Tags column, shared by both conversation tables so they cannot drift.
 * The filter control and the click handler are both injected, because each
 * table owns its own tag state.
 */
export const getConversationTagsColumn = <T extends TaggedRow>(
  filterComponent: React.ReactNode,
  onTagClick: (tag: string) => void,
  selectedTags: string[]
): TableV2Column<T> => ({
  name: 'Tags',
  cell: (row) => (
    <ConversationTagsCell
      tags={row.tags ?? []}
      onTagClick={onTagClick}
      selectedTags={selectedTags}
    />
  ),
  filterable: true,
  filterComponent,
  id: TAGS_COLUMN_ID,
  minWidth: '240px'
});
